/*
 * @Date: 2022-08-22 19:49:25
 * @LastEditors: kinfai
 * @Description: 控制台
 * @LastEditTime: 2022-08-31 10:38:37
 * @FilePath: \my-app\src\pages\ImManage\index.jsx
 */
import "./index.less";
import { useState, useMemo } from "react";
import Home from "../Home";
import LeaveMsg from "../LeaveMsg";
import ChatConversation from "../ChatConversation";
import { RouteContext } from "../../provide/route-context.js";
import useCs from "../../hooks/cs/index.js";



function ImManage(props) {
  const [page, goPage] = useState("Home");
  const [csInfo, updateCsInfo] = useState({
    id: 0,
    show: false
  })
  const [lastMsgInfo, updateLastMsgInfo] = useState({
    type: "text",
    value: "",
    messageId: 100,
    userName: "",
    avatar: ""
  })

  // 配置路由
  const Route = {
    Home,
    LeaveMsg,
    ChatConversation
  };

  // 请求API - 获取客服信息
  const {getCsId } = useCs()

  // 默认不穿则返回主页
  const changeView = async (path) => {
    if (path === 'ChatConversation') {
      const value = {
        ...csInfo,
        show: true
      }
      // 判断是否存在
      if (csInfo.id === 0) {
        value.id = await getCsId()
      }

      updateCsInfo(value)
      return false
    }

    goPage(path);
  };

  const View = () => {
    console.log("触发改变", page);
    return Route[page];
  };

  const MemoView = useMemo(View)

  return (
    <RouteContext.Provider value={{
      page,
      goPage: changeView,
      csInfo,
      updateCsInfo,
      lastMsgInfo,
      updateLastMsgInfo
    }}>
      <div className="g-im-manage" style={{
        visibility: props.show ? '' : 'hidden'
      }}>
        {
          csInfo.id !== 0 && <ChatConversation />
        }
        {/* <View></View> */}
        <MemoView />
        {/*<LeaveMsg></LeaveMsg>*/}
      </div>
    </RouteContext.Provider>
  );
}

ImManage.defaultProps = {
  show: true
}


export default ImManage;
